import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { useNotificationStore } from '@/common/store';
import { post } from '@/library/axios';
import type { MutationConfig } from '@/library/react-query';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type {
  ProductParamType,
  ProductShortKeyType,
} from './createOneTimeOrder';

export type CreateSubscriptionReq = {
  amount: number;
  productShortKey: ProductShortKeyType;
  productParams: ProductParamType;
};

export type CreateSubscriptionRes = {
  orderId: string;
  pgCustomerId: string;
  token: string;
  pgKey: string;
  subscriptionId: string;
};

export const createSubscription = ({
  customerId,
  payload,
}: {
  customerId: string;
  payload: CreateSubscriptionReq;
}): Promise<BaseResponse<CreateSubscriptionRes> | any> => {
  return post(
    `/customers/${customerId}/subscriptions?allowSubscription=true`,
    payload
  );
};

type UseCreateSubscription = {
  config?: MutationConfig<typeof createSubscription>;
};

export const useCreateSubscription = ({
  config,
}: UseCreateSubscription = {}) => {
  const { addNotification } = useNotificationStore();
  const mutation = useMutation({
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'SIP Creation Initiated',
        message: 'Please complete payment',
      });
    },
    ...config,
    mutationFn: createSubscription,
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
